var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedRightArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_630_55189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0905 20.2157C14.9222 20.0386 14.8306 19.8021 14.8358 19.5577C14.841 19.3134 14.9425 19.081 15.1182 18.9111L20.7994 13.4231H0.916363C0.671548 13.4231 0.43676 13.3259 0.263649 13.1527C0.0905386 12.9796 -0.00671387 12.7449 -0.00671387 12.5C-0.00671387 12.2552 0.0905386 12.0204 0.263649 11.8473C0.43676 11.6742 0.671548 11.577 0.916363 11.577H20.8025L15.1182 6.08957C14.9425 5.91959 14.841 5.68709 14.8358 5.44266C14.8306 5.19822 14.9221 4.96162 15.0905 4.78434C15.1734 4.6969 15.2728 4.62676 15.383 4.57799C15.4932 4.52922 15.612 4.50278 15.7324 4.50021C15.8529 4.49763 15.9727 4.51897 16.0848 4.56299C16.197 4.60701 16.2993 4.67283 16.3859 4.75665L23.717 11.8336C23.8062 11.9201 23.8771 12.0237 23.9255 12.1382C23.974 12.2527 23.9989 12.3757 23.9989 12.5C23.9989 12.6243 23.974 12.7474 23.9255 12.8619C23.8771 12.9763 23.8062 13.0799 23.717 13.1665L16.3859 20.2434C16.2993 20.3272 16.1969 20.393 16.0848 20.4369C15.9726 20.4809 15.8528 20.5022 15.7323 20.4996C15.6118 20.4969 15.4931 20.4704 15.3829 20.4216C15.2728 20.3728 15.1734 20.3026 15.0905 20.2151V20.2157Z",
    fill: "#CA001B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_630_55189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedRightArrowIcon);
export default __webpack_public_path__ + "static/media/red-right-arrow-icon.dea076c309b3aa200f8e9083b7e931bd.svg";
export { ForwardRef as ReactComponent };